<template>
    <div style="border-bottom:2px solid #007acc">
        <el-row :gutter="20" style="padding:10px; color:#666'; font-size:14px;">
            <el-col :span="12">
                <el-form label-position="left" inline class="demo-table-expand">
                    <el-form-item :label="gets('$仓库')+':'"  class="lineHeight">
                        <span>{{data.Warehouse ?( data.Warehouse.EnName +'-' + data.Warehouse.CnName) :'' }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$收件人')+':'" class="lineHeight">
                        <span>{{ data.ConsigneeName }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$邮编')+':'" class="lineHeight">
                        <span>{{ data.Zipcode }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$州')+':'" class="lineHeight">
                        <span>{{ data.Add_State }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$城市')+':'" class="lineHeight">
                        <span>{{ data.City }}</span>
                    </el-form-item>

                    <el-form-item :label="gets('$地址')+':'" class="lineHeight">
                        <span>{{ data.Address1 }} {{ data.Address2 }}</span>


                    </el-form-item>

                      <el-form-item :label="gets('$电话')+':'" class="lineHeight">
                        <span>{{ data.Contact }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$票件数')+':'" class="lineHeight">
                        <span>{{ data.BillQty }}</span>
                    </el-form-item>
                    <!-- <el-form-item :label="gets('$总费用')+':'">
                        <span>{{ data.OrderReceives &&  data.OrderReceives[0] ?data.OrderReceives[0].TotalFee.toFixed(2) :gets('$未生成账单') }}</span>
                    </el-form-item> -->
                    <el-form-item :label="gets('$跟踪号')+':'" class="lineHeight">
                        <span>{{ data.TrackingNo }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$订单备注')+':'" class="lineHeight">
                        <span style="color:blue">{{ data.CusRemark }}</span>
                    </el-form-item>
                     <!-- <el-form-item :label="gets('$平台创建时间')+':'" class="lineHeight">
                        <span style="color:red">{{ data.PlatFormCreateTime }}</span>
                    </el-form-item> -->
                         <el-form-item :label="gets('$标发状态')+':'" class="lineHeight">
                        <span style="color:blue">{{ data.IsPlatFormTrackFlag?"YES":"NO" }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$订单名称')+':'" class="lineHeight">
                        <span>{{ data.name }}</span>
                    </el-form-item>
                    <!-- <el-form-item :label="gets('$订单创建时间')+':'" class="lineHeight">
                        <span style="color:red">{{ data.PlatFormCreateTime }}</span>
                    </el-form-item> -->
                    <el-form-item :label="gets('$订单来源状态')+':'" class="lineHeight">
                        <span>{{ data.processing_method }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$税号')+':'" class="lineHeight">
                        <span>{{ data.DutyNum }}</span>
                    </el-form-item>
                    <el-form-item :label="gets('$实际重量')+':'" class="lineHeight">
                        <span>{{ data.ActualWeight }}</span>
                    </el-form-item>
                    <br/>
                    <el-form-item :label="gets('$系统备注')+':'" class="lineHeight">
                        <span style="color:red;white-space: pre-wrap;">{{ data.SysRemark }}</span>
                    </el-form-item><br/>
                    <el-form-item :label="gets('$错误信息')+':'" class="lineHeight">
                        <span style="color:red">{{ data.ErrorMessage }}</span>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="12">
                <table cellpadding="0" cellspacing="0" width="100%" border="0" style="margin: 0 0 10px;">
                    <tbody>
                        <tr>
                            <th id="ProductUrl">{{gets('$产品图片') }}</th>
                            <th id="SKU3">{{gets('SKU') }}</th>
                            <th id="sSKU3">{{gets('$平台SKU') }}</th>
                            <th id="Amount">{{gets('$数量') }}</th>
                           
                            <th id="USD">{{gets('$申报价值') }} </th>
                            <th></th>
                        </tr>
                        <tr v-for="i in data.OrderDetails">

                            <td>
                                <!-- <img :src="i.ImgUrl" class="max100" /> -->

                                 <el-popover
    placement="right"
    title=""
    trigger="hover">
    <img :src="i.ImgUrl" />
    <img slot="reference" :src="i.ImgUrl" style="max-height: 100px;max-width:100px">
   </el-popover>

                            </td>
                            <td>

<el-tooltip  placement="top">  <div slot="content">{{ i.Product==null?(i.EnName +"-"+i.CnName):(i.Product.EnName+"-"+i.Product.CnName) }}</div> <span>{{i.SKU}}</span> </el-tooltip>

                            </td>
                            <td >   <el-tooltip  placement="top">  <div slot="content">{{ (i.ShopProduct==null||i.ShopProduct.Title==null)?i.EnName:i.ShopProduct.Title }}</div> <span>{{ i.ShopSKU }}</span> </el-tooltip> </td>
                            <td>{{i.Quantity}}</td>
                         
                            <td>{{i.SinglePrice}}</td>
                            <td>
                                 <span  type="success" v-if="!i.Product && UserContext.UserType != 0 && i.ShopProduct" :size='"mini"' :style="{marginRight: '5px'}" >{{gets('$未绑定') }}</span>
                           </td>

                        </tr>
                    </tbody>
                </table>
            </el-col>
        </el-row>
    </div>
</template>

<style>

  .lineHeight
{

 margin-bottom: 0px;
  }
</style>

<script>
    import gets from '@/model/language.js'
    import {
        TableConfigGenerate
    } from '@/config/config.js'
    export default {
        props: ['data', 'item'],
        data() {
            return {}
        },
        created() {
        },
        watch: {},
        computed: {
            UserContext() {
                return window.rootVue.$store.state.UserRights.UserContext;
            }
        },
        methods: {
            gets: gets,
            ToSkuMapping(data) {
                console.log(data,"ToSkuMapping")
                var self = this;
                if (self.UserContext.UserType == 0) {
                } else {
                    self.$router.push('/MyAddShopProduct/'+data.ShopProduct.ID)
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// OrderTableExpandComponent1.vue?7f69f3a5